const type = 'CLOSE_CUSTOMER_PROTOCOL';

const closeCustomerProtocol = () => ({
  type,
});

export { type };
export default closeCustomerProtocol;
